import * as React from 'react'

import { cn } from '@/lib/utils'

function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        // Базовые стили
        'flex h-10 w-full rounded-lg border border-input bg-background px-3 py-2 text-sm',
        // Placeholder и файлы
        'placeholder:text-muted-foreground file:border-0 file:bg-transparent file:text-sm file:font-medium',
        // Переходы
        'transition-all duration-200',
        // Фокус — мягкое свечение
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/30 focus-visible:border-primary',
        // Disabled
        'disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-muted/50',
        // Ошибка
        'aria-invalid:border-destructive aria-invalid:ring-destructive/20',
        className,
      )}
      {...props}
    />
  )
}

export { Input }
